import {getTestProps} from '@benchling/js-test-utils';
import {Button} from '@mantine/core';
import React from 'react';
import {NodeToolbar} from 'reactflow';

import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

interface FlowchartNodeToolbarProps {
  isLocked?: boolean;
  onNodeEdit?: () => void;
  onNodeDelete?: () => void;
}

export default function FlowchartNodeToolbar({
  isLocked,
  onNodeEdit,
  onNodeDelete,
}: FlowchartNodeToolbarProps): JSX.Element | null {
  if (!onNodeEdit && !onNodeDelete) {
    return null;
  }

  const buttons: Array<{icon: BenchlingIconName; onClick: () => void; elementName: string}> = [];

  if (onNodeEdit) {
    buttons.push({
      icon: isLocked ? 'eye' : 'edit', // When locked, the sidepanel should still open but in read only mode
      onClick: onNodeEdit,
      elementName: 'editNodeButton',
    });
  }
  if (onNodeDelete) {
    buttons.push({
      icon: 'trash-can',
      onClick: onNodeDelete,
      elementName: 'deleteNodeButton',
    });
  }

  return (
    <NodeToolbar {...getTestProps({component: 'FlowchartNodeToolbar', element: 'root'})}>
      <Button.Group>
        {buttons.map((button) => (
          <Button
            key={button.icon}
            // eslint-disable-next-line no-restricted-syntax
            variant="filled"
            color="gray"
            size="md"
            compact={true}
            onClick={button.onClick}
            styles={{root: {padding: 10, width: 36, height: 36}}}
            {...getTestProps({component: 'FlowchartNodeToolbarButton', element: button.elementName})}
          >
            <BenchlingIcon icon={button.icon} />
          </Button>
        ))}
      </Button.Group>
    </NodeToolbar>
  );
}
